import AccessLogInfo from './access_log_info';

export default AccessLogInfo;
